import { MediaQuery } from 'utils/media_query';
import './index.scss';

(function ($) {
  'use strict';

  const $component = $('.q-exam-disciplines');

  $('.q-discipline-item .collapse', $component)
    .on('show.bs.collapse', e => {
      const $toggle = $(e.currentTarget).prev('.q-heading').find('.q-toggle');

      $toggle.find('.q-open').addClass('hidden');
      $toggle.find('.q-close').removeClass('hidden');
    })
    .on('hide.bs.collapse', e => {
      const $toggle = $(e.currentTarget).prev('.q-heading').find('.q-toggle');

      $toggle.find('.q-open').removeClass('hidden');
      $toggle.find('.q-close').addClass('hidden');
    });

  if (MediaQuery.is('lg')) {
    $('.q-discipline-item .collapse', $component).first().collapse('show');
  }
})(jQuery);
